import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import { Checkbox } from "components/ui/checkbox";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/ui/tooltip";
import { Loader2, Pencil } from "lucide-react";

const MultipleWebpages = ({
  scrapedData,
  selected,
  handleSelect,
  loading,
  url,
  submitHandler,
}) => {
  const maxSelect = 10;
  const limitReached = selected.length >= maxSelect;

  return (
    <div className="flex items-center justify-cente">
      <div className="relative">
        <div className="mb-4 -mt-1">
          {limitReached ? (
            <div className="bg-destructive/10 text-destructive border border-destructive/40 rounded px-4 py-3 text-sm flex items-center">
              <span>
                <b>You've selected 10/10 webpages.</b> To add another, please
                unselect one of your current URLs or{" "}
                <a
                  href="https://start.maybetech.com/talk_to_us"
                  target="_blank"
                  className="underline"
                  rel="noreferrer"
                >
                  contact us
                </a>{" "}
                to upgrade your account and increase your limit.
              </span>
            </div>
          ) : (
            <div className="bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30 rounded px-4 py-3 text-sm">
              Select <span className="font-bold">up to 10</span> webpages to add
              to your knowledge base.{" "}
              <a
                href="https://start.maybetech.com/talk_to_us"
                target="_blank"
                className="underline font-medium"
                rel="noreferrer"
              >
                Talk to us to add more.
              </a>
            </div>
          )}
        </div>

        <div className="rounded-[3px] px-3 py-6 mb-4 border border-border">
          <div className="text-muted-foreground text-sm mb-3">
            Current Source:{" "}
            <span className="text-foreground">
              {scrapedData?.urls?.length || 0} webpages
            </span>
          </div>
          <div className="flex items-center">
            <Input
              className="bg-muted border-border rounded-lg p-3 w-full text-muted-foreground text-sm"
              value={url}
              readOnly
              disabled
            />
            <span className="absolute right-[29%]">
              <Pencil className="h-3 w-3 text-muted-foreground" />
            </span>
            <span className="ml-4 text-muted-foreground text-xs text-nowrap">
              <span
                className={`font-semibold ${
                  selected?.length >= 10 ? "text-destructive" : "text-emerald-600 dark:text-emerald-400"
                }`}
              >
                {selected.length}/10{" "}
              </span>
              pages selected
            </span>
          </div>
        </div>

        <div className="border border-border rounded-lg p-4 mb-6 max-h-64 overflow-y-auto">
          <div className="grid grid-cols-1 gap-4">
            <TooltipProvider>
              {scrapedData?.urls?.map((page) => (
                <div
                  key={page}
                  className="flex items-center bg-background border border-border rounded px-3 py-4 truncate"
                >
                  <Checkbox
                    className="h-5 w-5 cursor-pointer"
                    id="check-vertical-list-group"
                    checked={selected.includes(page)}
                    onCheckedChange={() => handleSelect(page)}
                    disabled={
                      !selected.includes(page) && selected.length >= maxSelect
                    }
                  />
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className="ml-3 text-sm text-foreground max-w-[420px] truncate">
                        {page}
                      </span>
                    </TooltipTrigger>
                    <TooltipContent side="top">{page}</TooltipContent>
                  </Tooltip>
                </div>
              ))}
            </TooltipProvider>
          </div>
          {loading && (
            <Loader2 className="w-10 h-10 mt-5 animate-spin text-muted-foreground" />
          )}
        </div>
        {/* Next button */}
        <Button
          type="button"
          className="w-full py-2 h-auto text-lg font-medium"
          disabled={selected.length === 0 || scrapedData.loading}
          onClick={submitHandler}
        >
          {scrapedData.loading ? "Wait..." : "Next"}
        </Button>
      </div>
    </div>
  );
};

export default MultipleWebpages;
